export default __webpack_public_path__ + "static/media/chime2.5e738a97.mp3";